import { useState } from "react";
import Hearder from "../commun/Hearder"
import SideBar from "../commun/SideBar"
import swal from "sweetalert";
import { PropertySaveMarketsegment } from "../../Services/Service";
import { useNavigate } from "react-router-dom";


export const MarketSegmant = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        ID: 0,
        Code: "",
        MarketSeg: ""
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const result = await PropertySaveMarketsegment(formData);

            swal("Market segment added successfully!", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                navigate("/Property/MarketSagmentList", { state: { showSuccess: true } });
            });
            console.log("API response:", result);
            // Reset form
            setFormData({ ID: 0, Code: "", MarketSeg: "" });
        } catch (error) {
            console.log("Error adding market segment", error);
            alert("Failed to add market segment!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">Property Markect Segmant </div>
                                        </div>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Code</label>
                                                            <input type="number" name="Code" className="form-control" placeholder="Enter Code" value={formData.Code}
                                                                onChange={handleChange} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-block mb-3">
                                                            <label className="col-form-label">Market Segmant</label>
                                                            {/* <input type="text" name="MarketSeg" className="form-control" placeholder="Enter market Segment" value={formData.MarketSeg}
                                                                onChange={handleChange} required /> */}
                                                            <select className="form-control form-select" name="MarketSeg" value={formData.MarketSeg}
                                                                onChange={handleChange}>
                                                                <option value="">Select Market segment</option>
                                                                <option value="ADH">Adhoc</option>
                                                                <option value="AIR">Airline/ Crew</option>
                                                                <option value="BAR">Rate htmlFor the day</option>
                                                                <option value="CMP">Complimentary</option>
                                                                <option value="CNC">Corporate Non Contracted</option>
                                                                <option value="CNF">Conference</option>
                                                                <option value="COR">Corporate Negotiated Rate</option>
                                                                <option value="CRT">Consortia</option>
                                                                <option value="DAY">Day Use</option>
                                                                <option value="GOV">Government</option>
                                                                <option value="HSU">House Use</option>
                                                                <option value="LNG">Long Stay</option>
                                                                <option value="LYT">Loyalty</option>
                                                                <option value="OTA">Online Travel Agent</option>
                                                                <option value="OWN">Owners</option>
                                                                <option value="PHR">Pharma Group</option>
                                                                <option value="PKG">Package</option>
                                                                <option value="PSU">Public Sector Unit</option>
                                                                <option value="PUB">Rack/ Publish tariff</option>
                                                                <option value="RED">Redemption</option>
                                                                <option value="RFP">Corporate RFP</option>
                                                                <option value="TRA">Travel Agent</option>
                                                                <option value="WDD">Wedding</option>
                                                                <option value="WEB">Brand Web Site</option>
                                                                <option value="A">Contract</option>
                                                                <option value="B">TR - Promotions Global</option>
                                                                <option value="CMP">Complimentary Rooms</option>
                                                                <option value="D">TR - Member Discounts</option>
                                                                <option value="E">TR - Negotiated Global</option>
                                                                <option value="G">TR - Government</option>
                                                                <option value="GAS">GR - ASSOCIATION</option>
                                                                <option value="GCP">GR - CORPORATE</option>
                                                                <option value="GCW">GR - CITYWIDE</option>
                                                                <option value="GGV">GR - GOVERNMENT</option>
                                                                <option value="GIC">GR - SMERF</option>
                                                                <option value="GSF">GR - SMERF</option>
                                                                <option value="GTT">GR - TOUR & TRAVEL</option>
                                                                <option value="H">TR - Promotions Local</option>
                                                                <option value="HSE">House Use</option>
                                                                <option value="L">TR - Negotiated Local</option>
                                                                <option value="M">TR - Loyalty</option>
                                                                <option value="O">TR - OTA Opaque</option>
                                                                <option value="P">TR - OTA Promotions</option>
                                                                <option value="Q">TR - OTA Retail</option>
                                                                <option value="R">TR - Retail</option>
                                                                <option value="T">TR - TMC</option>
                                                                <option value="X">TR - Wholesale Discounts</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-action text-end">
                                                    <button type="submit" className="btn btn-primary">
                                                        submit
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}
